import { useState } from 'react';
import PropTypes from 'prop-types';
import '../Components/Styles/VideoEditor.css';

const DecartResultPreview = ({ result, isVideo, onSave, onCancel }) => {
  const [format, setFormat] = useState('jpeg');
  const [promptText, setPromptText] = useState('');

  const getBase64Size = (base64String) => {
    if (!base64String) return 0;
    const stringLength = base64String.length - (base64String.indexOf(',') + 1);
    const sizeInBytes = (stringLength * 3) / 4;
    return Math.round(sizeInBytes / 1024);
  };

  const handleSave = () => {
    const resultData = {
      src: result,
      format: isVideo ? 'mp4' : format,
      size: getBase64Size(result)
    };
    onSave(resultData);
  };

  const handleDownload = () => {
    const link = document.createElement('a');
    link.href = `data:${isVideo ? 'video/mp4' : 'image/jpeg'};base64,${result}`;
    link.download = `decart-result.${isVideo ? 'mp4' : format}`;
    link.click();
  };

  return (
    <div className="video-editor-overlay">
      <div className="video-editor-modal">
        <div className="video-editor-header">
          <h3>🤖 Decart AI Result</h3>
          <button 
            className="editor-close-btn" 
            onClick={onCancel}
            aria-label="Close preview"
          >
            ✕
          </button>
        </div>

<div className="decart-result-preview">
          {result && (
            isVideo ? (
              <video 
                src={`data:video/mp4;base64,${result}`} 
                alt="Decart AI Result" 
                className="decart-result-image"
                autoPlay
                muted
                loop
                playsInline
              />
            ) : (
              <img 
                src={`data:image/jpeg;base64,${result}`} 
                alt="Decart AI Result" 
                className="decart-result-image"
              />
            )
          )}
        </div>

        {!isVideo && (
          <div className="editor-content">
            <div className="control-section">
              <label>💾 Output Format</label>
              <div className="format-options">
                <label className="format-option">
                  <input
                    type="radio"
                    value="jpeg"
                    checked={format === 'jpeg'}
                    onChange={(e) => setFormat(e.target.value)}
                  />
                  <span>JPEG</span>
                  <small>Image format</small>
                </label>
                <label className="format-option">
                  <input
                    type="radio"
                    value="png"
                    checked={format === 'png'}
                    onChange={(e) => setFormat(e.target.value)}
                  />
                  <span>PNG</span>
                  <small>Lossless</small>
                </label>
              </div>
            </div>

            <div className="control-section">
              <label>📝 Applied Prompt</label>
              <textarea
                className="decart-prompt-display"
                value={promptText || "Professional AI enhancement applied"}
                onChange={(e) => setPromptText(e.target.value)}
                placeholder="Enter additional notes..."
                rows={2}
                disabled
              />
            </div>

            <div className="decart-info">
              <p>ℹ️ This result was generated by Decart AI. You can save it to your images or download it.</p>
              <p>📏 Size: {getBase64Size(result)}KB</p>
            </div>
          </div>
        )}

        {isVideo && (
          <div className="editor-content" style={{ padding: '20px 24px' }}>
            <div className="decart-info">
              <p>ℹ️ This video was processed by Decart AI. You can save it to your images or download it.</p>
              <p>📏 Size: {getBase64Size(result)}KB</p>
            </div>
          </div>
        )}

        <div className="editor-actions">
          <button 
            className="editor-btn secondary" 
            onClick={onCancel}
          >
            ❌ Cancel
          </button>
          <button 
            className="editor-btn secondary" 
            onClick={handleDownload}
          >
            💾 Download
          </button>
          <button 
            className="editor-btn primary" 
            onClick={handleSave}
          >
            ✅ Save to Images
          </button>
        </div>
      </div>
    </div>
  );
};

DecartResultPreview.propTypes = {
  result: PropTypes.string,
  isVideo: PropTypes.bool,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

DecartResultPreview.defaultProps = {
  result: null,
  isVideo: false
};

export default DecartResultPreview;